// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-7030c497]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.scroll-show[data-v-7030c497]{align-items:center;border-radius:50%;cursor:pointer;display:flex;font-size:20px;height:140px;justify-content:center;overflow:visible;position:fixed;width:140px;z-index:5}.site-device-750 .scroll-show[data-v-7030c497]{height:70px;width:70px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
